if (!customElements.get('product-carousel')) {
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-carousel__track');
      if (!this.track) return;
      this.onScroll = this.update.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    // Fluid columns in JS, as a plain number: Firefox can't divide lengths in CSS calc().
    updateInfoCardColumns() {
      if (!this.classList.contains('product-carousel--info-cards')) return;
      const minCols = 1.5;
      const maxCols = 5;
      const minW = 375;
      const maxW = 1024;
      const t = Math.min(1, Math.max(0, (window.innerWidth - minW) / (maxW - minW)));
      this.style.setProperty('--carousel-columns', (minCols + (maxCols - minCols) * t).toFixed(4));
    }

    update() {
      this.updateInfoCardColumns();
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;
      const visible = scrollWidth > 0 ? clientWidth / scrollWidth : 1;
      const progress = maxScroll > 0 ? Math.abs(scrollLeft) / maxScroll : 0;
      this.style.setProperty('--carousel-visible', visible.toFixed(4));
      this.style.setProperty('--carousel-progress', Math.min(1, progress).toFixed(4));
      this.classList.toggle('product-carousel--overflowing', maxScroll > 1);
    }
  }
  customElements.define('product-carousel', ProductCarousel);
}
